$(function (e) {
  $('#change-lang').change(function(e){
      location.href = '/lang/'+$(this).val();
  })

  $('select.select2').select2();

  $('.boxes-position').owlCarousel({
      loop: false,
      nav: true,
      autoplay:true,
      autoplayTimeout:20000,
      margin:15,
      navText: ["<span>←</span>","<span>→</span>"],
      items:4,
      responsive:{
          0:{
              items:1,
              nav: false,
          },
          767:{
              items:2,
              nav: false,
          },
          992:{
              items:4
          }
      }
  })

  $('.ominext-news').owlCarousel({
      dots:true,
      margin:15,
      autoplay:true,
      autoplayTimeout:20000,
      items:3,
      responsive:{
          0:{
              items:1,
              dots:true
          },
          767:{
              items:2,
              dots:true
          },
          992:{
              items:3
          }
      }
  })

  let feedback_owl = $('.feedback-list').owlCarousel({
      dots:true,
      nav:true,
      items:1,
      autoplay:false,
      autoplayTimeout:20000,
      autoplayHoverPause:true,
      loop: true,
      animateIn: 'animate__animated animate__fadeIn',
      animateOut: 'animate__animated animate__fadeOut',
      navText: ["<span>←</span>","<span>→</span>"],
  })

  let feedback_owl_image = $('.feedback-list-image').owlCarousel({
    items:1,
    dots:false,
    mouseDrag:false,
    animateIn: 'animate__animated animate__fadeIn',
    animateOut: 'animate__animated animate__fadeOut',
})

  feedback_owl.on('changed.owl.carousel', function(e) {
    feedback_owl_image.trigger('to.owl.carousel',e.page.index);
  });

  $('.box-slide').owlCarousel({
      dots:true,
      items:1,
      dotsData: true,
      autoplay:true,
      autoplayTimeout:20000,
      responsive:{
          0:{
              dots:false
          },
          767:{
              dots:true
          },
          992:{
              dots:true
          }
      }
  })

  $('.slide-thongdiep').owlCarousel({
    dots:true,
    items:1,
    autoplay:false,
    loop:false,
    autoplayTimeout:20000,
    responsive:{
      992:{
        dots:true
      }
    }
  })

  $('#three-line').click(function(e){
      $('.menu-desktop').addClass('opened');
      $('body').css('overflow','hidden');
  });

  $('.menu-desktop').click(function(e){
    $('.menu-desktop').removeClass('opened');
    $('body').css('overflow','auto');
  });

  $('.menu-desktop ul').click(function(e){
      e.stopPropagation();
  });

  $(window).scroll(function (e) {
    if($(window).scrollTop() > 500){
        $('#back-to-top').show();
    }else{
        $('#back-to-top').hide();
    }
  });

  $('#back-to-top').click(function(e){
    $('html, body').animate({scrollTop: 0}, 500);
  })

  $('#play-video').click(function(){
    const containID = $(this).attr('contain-id');
     $('#'+containID).show();
  })

  $('.video-container').click(function(e){
     $(this).hide();
  })

  const popupCenter = ({url, title, w, h}) => {
        // Fixes dual-screen position                             Most browsers      Firefox
        const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
        const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

        const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        const systemZoom = width / window.screen.availWidth;
        const left = (width - w) / 2 / systemZoom + dualScreenLeft
        const top = (height - h) / 2 / systemZoom + dualScreenTop
        const newWindow = window.open(url, title,
        `
        scrollbars=yes,
        width=${w / systemZoom},
        height=${h / systemZoom},
        top=${top},
        left=${left}
        `
        )
        if (window.focus) newWindow.focus();
    }

    $(".share-socical a.link").click(function(e){
        e.preventDefault();
        let url = this.href;
        let domain = url.split("/")[2];
        let w=585,h=368;
        switch(domain) {
            case "www.facebook.com":
                w=585,h=368;
                break;
            case "www.twitter.com":
                w=585,h=261;
                break;
            case "www.plus.google.com":
                w=517,h=511;
                break;
        }
        popupCenter({'url':url,'title':'test','w':w,'h':h});
        return false;
    });

    $("#pop-apply #upload-cv").click(function(){
        $("#pop-apply #file_cv").click();
    });

    $('.fake-link').click(function (e) {
        if($(this).attr('href') != undefined){
            location.href = $(this).attr('href');
        }
    });
    $(document).keyup(function(e) {
        // if (e.key === "Escape") {
        //     $("#pop-search").hide();
        //     $(".pop-bg").hide();
        // }
        if(e.which == 13 ){
            if($("#pop-apply").hasClass("active") && $("#pop-apply.active #upload-cv").is(":hover")){
                $("#pop-apply #upload-cv").click()
            }
        }
   });

    $(document).find(".pop-input-search").bind('keypress', function(e){
        var blockSpecialRegex = /[!@#$%^&*(){}[\]|,._=:/;<+?\\>1234567890]/g;
        let txtOrig = $(e.target).val()+e.key;
        let txtFinal = txtOrig.replace(blockSpecialRegex, '');
        if (txtOrig !== txtFinal || txtOrig.length > 55) {
            e.preventDefault();
        }
    });

    $(document).find(".pop-input-search").bind('paste', function(e){
        var blockSpecialRegex = /[!@#$%^&*(){}[\]|,._=:;<+?\\>]/g;
        let txtOrig = $(e.target).val()+e.originalEvent.clipboardData.getData('text');
        let txtFinal = txtOrig.replace(blockSpecialRegex, '');
        if (txtOrig !== txtFinal || txtOrig.length > 55) {
            e.preventDefault();
        }
    });

    $(window).scroll(function() {

        // selectors
        var $window = $(window),
            $body = $('body'),
            $panel = $('.about-ominext.reason');

        // Change 33% earlier than scroll position so colour is there when you arrive.
        var scroll = $window.scrollTop() + ($window.height() / 3);

        $panel.each(function () {
          var $this = $(this);

          // if position is within range of this panel.
          // So position of (position of top of div <= scroll position) && (position of bottom of div > scroll position).
          // Remember we set the scroll to 33% earlier in scroll var.
          if ($this.position().top <= scroll && $this.position().top + $this.height() > scroll) {

            $('.about-ominext').removeClass('show-bg');

            // Add class of currently active div
            $($this).addClass('show-bg');
          }
        });

      }).scroll();
})
